import { render, staticRenderFns } from "./wordLimitInput.vue?vue&type=template&id=3952a9e4&scoped=true"
import script from "./wordLimitInput.vue?vue&type=script&lang=js"
export * from "./wordLimitInput.vue?vue&type=script&lang=js"
import style0 from "./wordLimitInput.vue?vue&type=style&index=0&id=3952a9e4&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3952a9e4",
  null
  
)

export default component.exports